import { useApolloClient } from '@apollo/client';
import { useCurrentAccount } from '@application/api';
import { ACCOUNT_GET_BUYER_APPLICATIONS } from '@application/api/account/applications/useGetBuyerApplications';
import { ACCOUNT_GET_BUYER_UNPAID_APPLICATIONS } from '@application/api/account/applications/useGetBuyerUnpaidApplications';
import { MtApplicationAcceptSuccessPage } from '@presentation/pages';
import type { FC } from 'react';
import { useEffect } from 'react';
import type { MtApplicationAcceptSuccessPageControllerProps } from './types';

export * from './types';

export const MtApplicationAcceptSuccessPageController: FC<
  MtApplicationAcceptSuccessPageControllerProps
> = () => {
  const { currentAccountCheckoutPriceValue } = useCurrentAccount();

  const apolloClient = useApolloClient();

  useEffect(() => {
    apolloClient.refetchQueries({
      include: [ACCOUNT_GET_BUYER_APPLICATIONS, ACCOUNT_GET_BUYER_UNPAID_APPLICATIONS],
    });
  }, [apolloClient]);

  return <MtApplicationAcceptSuccessPage priceValue={currentAccountCheckoutPriceValue} />;
};
